import { render, staticRenderFns } from "./BODCharge.vue?vue&type=template&id=c8c88aa4&"
import script from "./BODCharge.vue?vue&type=script&lang=js&"
export * from "./BODCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports